import { fetchFMS as fetchFMSApi } from 'support/api/VideoApi';
import { HttpClient } from 'support/api/api-types';

export const FMS = 'FMS' as const;

export const fetchFMS = (ifa: string, lat: string, uuid: string) => {
  return {
    type: FMS,
    promise: (httpClient: HttpClient) => fetchFMSApi(httpClient, ifa, lat, uuid),
  };
};
